
<div #imageSlider id="imageSlider" class="hero-slider-container-v2" dpadScrollableHorizontal [scrollLeftPaddingPx]="scrollLeftPaddingPx">
    <div class="hero-slider-item-v2" *ngFor='let item of heroes; let i = index'>
        <app-hero-carousel-banner-smart-tv [heroItem]="item" [bannerId]="'hero-banner-' + (i+1)" [dpadStart]="currentFocus === i" (focused)="currentFocus = i; focused.emit()"></app-hero-carousel-banner-smart-tv>
    </div>
</div>
<div class="hero-indicator-container">
    <div class="hero-indicator" *ngFor='let item of heroes; let i = index'>
        <svg [class.active]="i === currentFocus" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" r="6"/>
        </svg>
    </div>
</div>
